export default "__VITE_ASSET__D2aFm835__"